export default "__VITE_ASSET__BdMEoMll__"